module.exports = __webpack_public_path__ + "media/images/common/ico-crown-black-5244f4251e11f648f627703c100f14bf.svg";